﻿(function () {
    'use strict';

    var serviceId = 'repository.auth';

    angular
        .module('app.services')
        .factory(serviceId, repositoryAuth);

    repositoryAuth.$inject = ['$http', '$q', 'common', 'repository.abstract', '$location', '$state'];

    function repositoryAuth($http, $q, common, abstractRepository, $location, $state) {
        var config = common.config;
        var _authentication = {
            isAuth: false,
            userName: ""
        };

        function Ctor(mgr) {
            this.manager = mgr;
            this.login = login;
            this.logOut = logOut;
            this.changeYard = changeYard;
            this.fillAuthData = fillAuthData;
            this.refreshToken = refreshToken;
            this.forceCloseSession = forceCloseSession;
        }
        abstractRepository.extend(Ctor);
        return Ctor;

        function login(loginData, languageId) {
            var requestObject = Object.assign({}, loginData);

            if (config.scope)
                requestObject.scope = config.scope;
            if (languageId)
                requestObject.scope = requestObject.scope ? `${requestObject.scope} ${languageId}` : languageId;            
            if (config.grantType)
                requestObject.grant_type = config.grantType;
            if (config.useRefreshTokens)
                requestObject.client_id = config.cld;

            var requestBody = [];
            for (var prop in requestObject)
                requestBody.push(encodeURIComponent(prop) + "=" + encodeURIComponent(requestObject[prop]));
            requestBody = requestBody.join("&");

            var deferred = $q.defer();
            var changePassword = common.localStorageService.get('changePassword');
            common.httpPostAuth(config.basePaths.Base_Path_Resources + 'token',
                requestBody,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                .then(
                    function (response) {
                        common.localStorageService.set(
                            'authorizationData',
                            Object.assign({
                                username: loginData.username,
                                dateTime: new Date()
                            }, response));
                        common.localStorageService.set('changePassword', changePassword);
                        _authentication.isAuth = true;
                        _authentication.userName = loginData.username;
                        deferred.resolve(response);
                    },
                    function (err, status) {
                        logOut();
                        deferred.reject(err);
                    });
            return deferred.promise;
        }

        function forceCloseSession(userSessionId) {
            var latitude = common.localStorageService.get('latitude');
            var longitude = common.localStorageService.get('longitude');

            // Mostrar loader
            $("#divLoader").removeClass("hideLoader");
            $("#divLoader").addClass("loader");

            // Primero obtener IP pública
            return $http.get('https://api.ipify.org?format=json')
                .then(function (response) {
                    var ip = response.data.ip;

                    var model = {
                        userSessionId: userSessionId,
                        latitude: latitude ? latitude : 0,
                        longitude: longitude ? longitude : 0,
                        sessionClosingDate: new Date(),
                        appCode: 'TDPOR',
                        ip: ip
                    };

                    // Llamar al endpoint para cerrar la sesión
                    return common.httpPost(config.basePaths.Base_Path_Resources + 'Security/ForceCloseUserActiveConnection', model);
                })
                .then(function (result) {
                    // Ocultar loader al terminar todo bien
                    $("#divLoader").removeClass("loader");
                    $("#divLoader").addClass("hideLoader");
                    return result;
                })
                .catch(function (error) {
                    console.error("Error obteniendo IP o cerrando sesión:", error);
                    toastr.error("No se pudo cerrar la sesión");

                    // Ocultar loader en caso de error también
                    $("#divLoader").removeClass("loader");
                    $("#divLoader").addClass("hideLoader");
                });
        }

        function logOut(isForDealocateSession) {
            if (!isForDealocateSession) {                
                var latitude = common.localStorageService.get('latitude');
                var longitude = common.localStorageService.get('longitude');
                common.localStorageService.clearAll();
                common.localStorageService.set('latitude', latitude);
                common.localStorageService.set('longitude', longitude); 
                _authentication.isAuth = false;
                _authentication.userName = "";                                   
                return;
            }

            var latitude = common.localStorageService.get('latitude');
            var longitude = common.localStorageService.get('longitude');
            var authData = common.localStorageService.get('authorizationData');
            
            var model = {
                UserId: 0,
                Latitude: latitude ? latitude : 0,
                Longitude: longitude ? longitude : 0,
                AppCode: 'TDPOR'
            };

            $.ajax({
                async: false,
                headers: {
                    'Authorization': 'Bearer ' + authData.access_token,
                    'Content-Type': 'application/json; charset=UTF-8',
                },
                url: config.basePaths.Base_Path_Resources + 'Security/DeallocateUserSessionAndAuditing',
                type: "POST",
                dataType: "json",
                data: JSON.stringify(model),
                success: function (response) {
                    var latitude = common.localStorageService.get('latitude');
                    var longitude = common.localStorageService.get('longitude');
                    common.localStorageService.clearAll();
                    common.localStorageService.set('latitude', latitude);
                    common.localStorageService.set('longitude', longitude); 
                    _authentication.isAuth = false;
                    _authentication.userName = "";
                    $location.path('/login');
                },
                error: function (err) {
                    console.log(err);
                    toastr.error("Se produjo un error");
                }
            });
            var latitude = common.localStorageService.get('latitude');
            var longitude = common.localStorageService.get('longitude');
            common.localStorageService.clearAll();
            common.localStorageService.set('latitude', latitude);
            common.localStorageService.set('longitude', longitude); 
            _authentication.isAuth = false;
            _authentication.userName = "";
            $location.path('/login');
        };
        
        
        function refreshToken(authData) {
            var deferred = $q.defer();
            var data = "grant_type=refresh_token&refresh_token=" + authData.refreshToken + "&client_id=" + config.cld;
            $http.post(config.basePaths.Base_Path_Resources + 'token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).success(function (response) {
                deferred.resolve(response);

            }).error(function (err, status) {
                logOut();
                deferred.reject(err);
            });
            return deferred.promise;
        };

        function fillAuthData() {
            var authData = common.localStorageService.get('authorizationData');
            if (!authData) {
                $location.path('/login');
            }
        };

        function changeYard(newYard) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'eir/GetVoyagesByNo?criteria=' + newYard);
        };
    }
})();
